// @flow

import React from 'react';
import { connect } from 'react-redux';
import './authMsg.css';

const AuthMsg = ({ authMsg, dispatch, provider }) => {
  if( provider !== undefined && provider !== authMsg.msgProvider ) return false;

  if (authMsg.message) {
    if (authMsg.msgRaw) {
      return (
        <div id='alert' className={'authMsg authMsgRaw ' + authMsg.msgType}>
          <p dangerouslySetInnerHTML={{__html: authMsg.message}}></p>
        </div>
      )
    } else if( authMsg.msgFloat ) {
      return(
        <div className={"error-float-message alert alert-" + authMsg.msgType}>
          <i className="icon-bell"></i>
          <span dangerouslySetInnerHTML={{__html: authMsg.message}}></span>
        </div>
      )
    } else {
      return(
        <div id='alert' className={`alert alert-${authMsg.msgType} authMsg`}>
          <p dangerouslySetInnerHTML={{__html: authMsg.message}}></p>
        </div>
      )
    }

  } else {
    return null;
  }
}

const mapStateToProps = (state) => {
  return { authMsg: state.authMsg };
}

export default connect(mapStateToProps)(AuthMsg);



// WEBPACK FOOTER //
// ./src/components/session/authMsg/authMsg.js